import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { Card, Checkbox } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const IncludeNonWorkingDay = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();

  return (
    <Card>
      <Checkbox
        label={t('form.includeNonWorkDayInPrep.label')}
        helpText={t('form.includeNonWorkDayInPrep.helpText')}
        checked={generalSettings.includeNonWorkDayInPrep}
        onChange={() => dispatch(handleSaveSettings({ includeNonWorkDayInPrep: !generalSettings.includeNonWorkDayInPrep }))}
      />
    </Card>
  );
};
